/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { CpcDocumentMessageType } from '../enums/cpc-document-message-type.enum';
import { AdminExportAction } from '../enums/admin-export-action.enum';
import { CaseManagementUserDto } from './case-management-user-dto';
import { ExportLogEntryStatus } from '../enums/export-log-entry-status.enum';
import { ExportLogStatusChangeDto } from './export-log-status-change-dto';

//<custom-head>
import { orderBy } from 'lodash-es';
import {
  formattedDate,
  parseDate,
  translateAdminExportAction,
  translateMessageType
} from 'app/utils';
//</custom-head>

export class ExportLogEntryDto {
  public id: number = undefined;
  public clearanceCaseId: string = undefined;
  public exportedById: string = undefined;
  public clearanceCaseVersion: number = undefined;
  public messageType: CpcDocumentMessageType;
  public fileName: string = undefined;
  public reference: string = undefined;
  public action: AdminExportAction;
  public handler: CaseManagementUserDto;
  public dateTimeUtc: Date | string;
  public status: ExportLogEntryStatus;
  public lastUpdatedUtc: Date | string;
  public statusChanges: ExportLogStatusChangeDto[];
  public latestStatusChange: ExportLogStatusChangeDto;

  //<custom-body>
  constructor(source: ExportLogEntryDto) {
    Object.assign(this, source);
    this.statusChanges = orderBy(
      source.statusChanges || [],
      s => s.timestampUtc,
      ['desc']
    ).map(s => new ExportLogStatusChangeDto(s));
  }

  public get formattedDate(): string {
    return formattedDate(parseDate(this.dateTimeUtc));
  }

  public get logLabel(): string {
    return `${translateMessageType(
      this.messageType
    )}: ${translateAdminExportAction(this.action)}`;
  }

  public get logReference(): string {
    return `v${this.clearanceCaseVersion} (${this.reference})`;
  }

  public get createdByName(): string {
    if (
      this.action ==
      (AdminExportAction.ChangedStatus || AdminExportAction.ChangedStatus)
    ) {
      return this.handler ? this.handler.name : 'Okänd';
    }
    return 'System';
  }

  public get byClient(): boolean {
    return false;
  }

  public get internal(): boolean {
    return false;
  }

  public get requiresAdminRole(): boolean {
    return this.action != null;
  }

  public get errorMessages(): string[] {
    return [];
  }
  //</custom-body>
}
